/** Maximum number of skills a professional can have. */
export const MAX_SKILLS = 5;

/** Maximum openings (candidates) on a posted shift. */
export const MAX_SHIFT_CANDIDATES = 50;

/** Platform default currency. */
export const DEFAULT_CURRENCY = "CAD" as const;

/**
 * Default page size for paginated list queries and tables.
 * Specialized feeds (dashboard cards, popovers, calendars) keep their own sizes.
 */
export const DEFAULT_PAGE_SIZE = 20;

/** Rows-per-page choices shown by list pagination controls. */
export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100] as const;

/** Default debounce for search inputs before issuing API queries. */
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * Debounce for search boxes that hit a paginated server endpoint on every
 * settled keystroke. Wider than `SEARCH_DEBOUNCE_MS` so a normal typing speed
 * stays at a single request.
 */
export const SERVER_SEARCH_DEBOUNCE_MS = 500;

/** Maximum number of attempts to retry fetching the role claim. */
export const ROLE_CLAIM_RETRY_ATTEMPTS = 5;

/** Base delay in milliseconds between retry attempts. */
export const ROLE_CLAIM_RETRY_BASE_DELAY_MS = 1000;
